import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useApiKey } from '../context/ApiKeyContext';
import Auth from './Auth';

interface HeaderProps {
  activeTab: 'home' | 'upload' | 'conversations';
  setActiveTab: (tab: 'home' | 'upload' | 'conversations') => void;
}

const Header: React.FC<HeaderProps> = ({ activeTab, setActiveTab }) => {
  const { user, logout } = useAuth();
  const { hasKey, openKeyModal } = useApiKey();
  const [showAuth, setShowAuth] = useState(false);
  const [showProfile, setShowProfile] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <>
    <header style={{
      backgroundColor: '#000000',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.3)',
      borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
    }}>
      <div className="container mx-auto px-8">
        <div className="flex justify-between items-center" style={{ padding: '1rem 0' }}>
          <div className="flex items-center">
            <button
              type="button"
              onClick={() => setActiveTab('home')}
              style={{
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                padding: 0,
              }}
            >
              <h1 style={{
                fontSize: '1.75rem',
                fontWeight: 800,
                color: '#ffffff',
                letterSpacing: '0.15em',
                textTransform: 'uppercase',
                fontFamily: "'Inter', sans-serif",
                margin: 0
              }}>
                PromptX
              </h1>
            </button>
          </div>
          
          <nav className="flex gap-4 items-center">
            <button
              onClick={() => setActiveTab('home')}
              style={{
                background: activeTab === 'home' ? '#ffffff' : 'transparent',
                border: '1px solid #ffffff',
                color: activeTab === 'home' ? '#000000' : '#ffffff',
                padding: '0.6rem 1.75rem',
                fontSize: '0.9rem',
                fontWeight: 600,
                letterSpacing: '0.05em',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                fontFamily: "'Inter', sans-serif",
                borderRadius: 0
              }}
              onMouseEnter={(e) => {
                if (activeTab !== 'home') {
                  e.currentTarget.style.background = '#ffffff';
                  e.currentTarget.style.color = '#000000';
                }
              }}
              onMouseLeave={(e) => {
                if (activeTab !== 'home') {
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.color = '#ffffff';
                }
              }}
            >
              HOME
            </button>
            <button
              onClick={() => setActiveTab('upload')}
              style={{
                background: activeTab === 'upload' ? '#ffffff' : 'transparent',
                border: '1px solid #ffffff',
                color: activeTab === 'upload' ? '#000000' : '#ffffff',
                padding: '0.6rem 1.75rem',
                fontSize: '0.9rem',
                fontWeight: 600,
                letterSpacing: '0.05em',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                fontFamily: "'Inter', sans-serif",
                borderRadius: 0
              }}
              onMouseEnter={(e) => {
                if (activeTab !== 'upload') {
                  e.currentTarget.style.background = '#ffffff';
                  e.currentTarget.style.color = '#000000';
                }
              }}
              onMouseLeave={(e) => {
                if (activeTab !== 'upload') {
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.color = '#ffffff';
                }
              }}
            >
              UPLOAD
            </button>
            <button
              onClick={() => setActiveTab('conversations')}
              style={{
                background: activeTab === 'conversations' ? '#ffffff' : 'transparent',
                border: '1px solid #ffffff',
                color: activeTab === 'conversations' ? '#000000' : '#ffffff',
                padding: '0.6rem 1.75rem',
                fontSize: '0.9rem',
                fontWeight: 600,
                letterSpacing: '0.05em',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                fontFamily: "'Inter', sans-serif",
                borderRadius: 0
              }}
              onMouseEnter={(e) => {
                if (activeTab !== 'conversations') {
                  e.currentTarget.style.background = '#ffffff';
                  e.currentTarget.style.color = '#000000';
                }
              }}
              onMouseLeave={(e) => {
                if (activeTab !== 'conversations') {
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.color = '#ffffff';
                }
              }}
            >
              CONVERSATIONS
            </button>
            

            {/* Auth Section */}
            <div style={{ marginLeft: '1rem', borderLeft: '1px solid rgba(255, 255, 255, 0.2)', paddingLeft: '1rem' }}>
              {user ? (
                <div className="flex items-center gap-4">
                  <button
                    onClick={openKeyModal}
                    style={{
                      background: hasKey ? 'rgba(46, 204, 113, 0.15)' : 'transparent',
                      border: hasKey ? '1px solid #2ecc71' : '1px solid #ffffff',
                      color: hasKey ? '#2ecc71' : '#ffffff',
                      padding: '0.6rem 1.25rem',
                      fontSize: '0.85rem',
                      fontWeight: 600,
                      letterSpacing: '0.05em',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      fontFamily: "'Inter', sans-serif",
                      borderRadius: 0,
                      textTransform: 'uppercase',
                    }}
                    onMouseEnter={(e) => {
                      if (!hasKey) {
                        e.currentTarget.style.background = '#ffffff';
                        e.currentTarget.style.color = '#000000';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!hasKey) {
                        e.currentTarget.style.background = 'transparent';
                        e.currentTarget.style.color = '#ffffff';
                      }
                    }}
                  >
                    {hasKey ? 'API KEY SET' : 'ADD API KEY'}
                  </button>
                  <div className="relative">
                  <button
                    onClick={() => setShowProfile((v) => !v)}
                    style={{
                      background: 'transparent',
                      border: '1px solid #ffffff',
                      color: '#ffffff',
                      padding: '0.5rem 1rem',
                      fontSize: '0.85rem',
                      fontWeight: 600,
                      letterSpacing: '0.05em',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      fontFamily: "'Inter', sans-serif",
                      borderRadius: 0,
                      textTransform: 'uppercase'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = '#ffffff';
                      e.currentTarget.style.color = '#000000';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'transparent';
                      e.currentTarget.style.color = '#ffffff';
                    }}
                  >
                    {(user.displayName || user.email || '').split(' ')[0] || 'Profile'}
                  </button>
                  {showProfile && (
                    <div style={{
                      position: 'absolute',
                      right: 0,
                      top: '2.75rem',
                      backgroundColor: '#000000',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      padding: '0.5rem',
                      minWidth: '12rem',
                      zIndex: 1001
                    }}>
                      <div style={{ padding: '0.5rem 0.75rem' }}>
                        <div style={{ color: '#ffffff', fontFamily: "'Inter', sans-serif", fontSize: '0.9rem', marginBottom: '0.25rem' }}>
                          {user.displayName || user.email}
                        </div>
                        {user.email && (
                          <div style={{ color: 'rgba(255,255,255,0.7)', fontFamily: "'Inter', sans-serif", fontSize: '0.8rem' }}>
                            {user.email}
                          </div>
                        )}
                      </div>
                      <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', margin: '0.25rem 0' }} />
                      <button
                        onClick={handleLogout}
                        style={{
                          width: '100%',
                          background: 'transparent',
                          border: '1px solid #ffffff',
                          color: '#ffffff',
                          padding: '0.5rem 0.75rem',
                          fontSize: '0.85rem',
                          fontWeight: 600,
                          letterSpacing: '0.05em',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                          fontFamily: "'Inter', sans-serif",
                          borderRadius: 0,
                          textTransform: 'uppercase'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = '#ffffff';
                          e.currentTarget.style.color = '#000000';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = 'transparent';
                          e.currentTarget.style.color = '#ffffff';
                        }}
                      >
                        Logout
                      </button>
                    </div>
                  )}
                  </div>
                </div>
              ) : (
                <button
                  onClick={() => setShowAuth(true)}
                  style={{
                    background: '#ffffff',
                    border: '1px solid #ffffff',
                    color: '#000000',
                    padding: '0.6rem 1.75rem',
                    fontSize: '0.9rem',
                    fontWeight: 600,
                    letterSpacing: '0.05em',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    fontFamily: "'Inter', sans-serif",
                    borderRadius: 0,
                    textTransform: 'uppercase'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'transparent';
                    e.currentTarget.style.color = '#ffffff';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = '#ffffff';
                    e.currentTarget.style.color = '#000000';
                  }}
                >
                  Login / Sign Up
                </button>
              )}
            </div>
          </nav>
        </div>
      </div>
    </header>

    {/* Auth Modal */}
    {showAuth && <Auth onClose={() => setShowAuth(false)} />}
    
    </>
  );
};

export default Header;
